var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container videos"},[(_vm.videos.length > 0)?_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.videos),function(video){return _c('video-item',{key:video.id,attrs:{"item":video}})})):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }